import React from 'react'
import StartInterviewLayout from '../../components/layout/StartInterviewLayout'

const Jquery = () => {
  return (
   <StartInterviewLayout type="jquery" />
  )
}

export default Jquery